import { render } from "./Main-categories.vue?vue&type=template&id=5715db2e&scoped=true"
import script from "./Main-categories.vue?vue&type=script&lang=js"
export * from "./Main-categories.vue?vue&type=script&lang=js"

import "./Main-categories.vue?vue&type=style&index=0&id=5715db2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5715db2e"]])

export default __exports__